import React from "react"
import classes from "./Tabs.module.css"
import Tab from "../../components/Tabs/Tab/Tab"
import { useTranslation } from "react-i18next"
import { valid_key } from "../../Utils"

const Tabs = props => {
    const { t } = useTranslation()

    const get_tabs = () => {
        const r = [
            t("translation:CommonMsg.Glossary.Lottery") + " (Normal)",
            t("translation:CommonMsg.Glossary.Lottery") + " (Splatfest)",
            t("translation:CommonMsg.Glossary.Vendor"),
            t("translation:CommonMsg.Glossary.Byname"),
            t("translation:CommonMsg.Glossary.NamePlateBg"),
        ]
        if (valid_key()) {
            r.push(
                t("translation:LayoutMsg.Cmn_GuideBtn_00.CashExchange") +
                    " (" +
                    t("translation:LayoutMsg.Cmn_Menu_00.L_BtnFestStage_02-T_BlackText_00") +
                    ")"
            )

            r.push(t("translation:LayoutMsg.Cmn_Menu_00.T_Shop_00"))
        }
        return r
    }

    return (
        <ul className={classes.Nav}>
            {get_tabs().map((v, idx) => {
                return <Tab title={v} key={idx} clicked={props.clicked} active={props.active === idx} num={idx} />
            })}
        </ul>
    )
}

export default Tabs
